import { ContentListDescription, ContentPanel, Option } from '@hopskipdrive/react-components';
import { Box } from '@mui/material';
import { colorTokens, variables } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const seriesDayOptionStyles = {
  '&:not(.Mui-disabled)': {
    backgroundColor: colorTokens.background.light,
    color: colorTokens.text.secondary,
    fontWeight: 400,
    '&[aria-pressed="true"]': {
      backgroundColor: colorTokens.primary.dark,
      color: colorTokens.text.contrast,
      fontWeight: 700,
    },
    '&:hover, &:focus-visible': {
      backgroundColor: colorTokens.primary.surface,
      color: colorTokens.text.hover,
      '&[aria-pressed="true"]': {
        backgroundColor: colorTokens.primary.light,
        color: colorTokens.text.contrast,
      },
    },
    '.MuiChip-label': {
      color: 'inherit',
      fontWeight: 'inherit',
    },
  },
};

export const MiniOption = styled(Option)`
  .MuiChip-label {
    user-select: text;
  }
  min-width: 26px !important;
  max-width: 26px;
  max-height: 26px;
  padding: 4px !important;
  margin-right: 4px !important;
`;

export const DateSectionContainer = styled(ContentPanel)`
  .MuiAccordion-root {
    .MuiAccordionSummary-root {
      padding: 0 !important;
      ${variables.mediaQuery.lessThan('tablet')`
        flex-direction: column;
        align-items: flex-start;
      `}
    }
    .Mui-expanded {
      min-height: 0;
      margin: 0;
    }
    .MuiAccordionDetails-root {
      padding: 0;

      .MuiBox-root {
        margin: 0;
      }
    }
    .MuiAccordionSummary-content > .MuiBox-root {
      gap: 0;
      width: 100%;
      margin: 0;
      align-items: center;
      ${variables.mediaQuery.lessThan('desktop')`
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
      `}
    }
    .variance-count {
      font-size: 14px;
      font-weight: 400;
      margin-left: auto;
      ${variables.mediaQuery.lessThan('desktop')`
        margin-left: 0;
      `}
    }
    dt {
      align-items: flex-start;
    }
    dl {
      justify-content: flex-start;
      ${variables.mediaQuery.lessThan('desktop')`
        flex-direction: column;
      `}
    }
    dd {
      align-items: flex-start !important;
    }
  }
  .core-date-picker-container {
    flex: 0 1 160px;
  }
  .core-date-picker {
    min-width: 160px;
  }
  .calendar-helper-text {
    flex: 0 1 500px;
  }
`;

export const MiniOptionBox = styled(Box)`
  margin-right: 7px;
  pointer-events: none;
  display: block;
`;

export const SeriesDateStringBox = styled(Box)`
  display: inline-block;
  margin-left: 7px;
  margin-top: 3px;

  ${variables.mediaQuery.lessThan('desktop')`
     margin-left: 0;
  `}
`;

export const DateText = styled.span`
  font-size: 1rem;
`;

export const CalendarDetails = styled(ContentListDescription)`
  margin-left: '51px';

  ${variables.mediaQuery.lessThan('desktop')`
     margin-left: 8px;
  `}
`;
